import { WebAlertService } from '../../services/web-alert.service';
import { EntitlementService } from '../../services/entitlement.service';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MessageService } from '../../services/message.service';

@Component({
  selector: 'app-web-alert',
  templateUrl: './web-alert.component.html',
  styleUrls: ['./web-alert.component.css']
})
export class WebAlertComponent implements OnInit {
  title: string;
  detail: string;
  showEditAlert = false;

  constructor(
    private webAlertService: WebAlertService,
    private entitlementService: EntitlementService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.getAlertData();
  }

  getAlertData() {
    const alertDataObs = this.webAlertService.getAlertData();

    alertDataObs.subscribe(data => {
      this.title = data.title;
      this.detail = data.detail;
    });
  }

  setAlertData() {
    const alertDataObs = this.webAlertService.setAlertData(
      this.title,
      this.detail
    );
    alertDataObs.subscribe(
      () => {
        this.showEditAlert = false;
        this.messageService.success('Successfully Updated Alert Information');
      },
      data => {
        this.showEditAlert = false;
        this.getAlertData();
        this.messageService.error(data.error);
      }
    );
  }

  hasEntitlement(entitlement: string): boolean {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  editAlertMeaasge() {
    this.closeAndResetEditAlert(); // Reset messages and text before editing
    this.showEditAlert = true;
  }

  closeAndResetEditAlert() {
    this.showEditAlert = false;
    this.getAlertData();
  }
}
